import ConfirmActionModal from './ConfirmActionModal';
import styles from './ConfirmarFinalizarModal.module.css';

// Confirmación antes de REINICIAR una asamblea finalizada (R219): vuelve a «Pendiente» y se descarta la foto del acta (utils/finalizarAsamblea.js).
// Comparte los estilos del aviso de finalizar (mismo subtítulo y texto).
export default function ConfirmarReiniciarModal({ asamblea, onClose, onConfirm, loading }) {
  const numero = asamblea?.number_assembly ?? asamblea?.id;
  return (
    <ConfirmActionModal
      title={`¿Reiniciar la asamblea${numero != null ? ` #${numero}` : ''}?`}
      onClose={onClose} onConfirm={onConfirm} loading={loading}
      confirmLabel="Reiniciar" confirmIcon="fa-history" maxWidth={520}>
      {asamblea?.property?.name && <p className={styles.subtitulo}>{asamblea.property.name}</p>}
      <p className={styles.texto}>
        La asamblea vuelve a <strong>«Pendiente»</strong> y se <strong>descarta la foto del acta</strong>: habrá que finalizarla otra vez para generarla de nuevo.
        Las preguntas siguen cerradas hasta que abras cada votación otra vez.
      </p>
    </ConfirmActionModal>
  );
}
